import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionUpdate/details/pageContext';

export const PetitionUpdateErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for PetitionUpdate page (error: ${error})`);
};
